class City {
  constructor(title, displayName, provinceId) {
    this.title = title;
    this.displayName = displayName;
    this.provinceId = provinceId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      cityId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      cityManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'استان', value: 'province', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'عنوان نمایشی', value: 'displayName', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن شهرستان';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش شهرستان';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getCityFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.city = new City('', '', null);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addCityFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش شهرستان';
        this.$refs.confirm.text = 'از ویرایش شهرستان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف شهرستان';
        this.$refs.confirm.text = 'از حذف شهرستان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addCityFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editCityFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteCityFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.cityId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
